export default function News() {
  return (
    <div className="scroll-mt-44 px-4 sm:px-6 lg:px-16 py-16" id="news">
      <h3 className="text-red-500 font-semibold text-3xl text-center mb-4 sm:text-2xl">
        NEWS & ARTICLE
      </h3>
      <p className="text-black font-serif text-4xl font-bold text-center mb-12 sm:text-2xl">
        Stay Update with SSPC
      </p>

      <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">
        {/* Card 1 */}
        <div className="max-w-sm w-full text-center">
          <img
            src={require("./news-1.jpg")}
            className="h-64 w-full object-cover rounded-lg"
            alt="logo"
          />
          <button className="border bg-gray-300 rounded-3xl px-4 py-1 mt-6 text-zinc-600 text-sm">
            LIFESTYLE
          </button>
          <h1 className="font-bold text-2xl mt-4 mb-4 cursor-pointer hover:text-red-500">
            FOOTING TRENCH <br /> TREATMENT
          </h1>
          <p className="text-zinc-600 font-medium text-sm leading-relaxed">
            The first step in pre-construction termite treatment involves
            treating the walls and base of the footing trench with our effective
            chemical solution.
          </p>
        </div>

        {/* Card 2 */}
        <div className="max-w-sm w-full text-center">
          <img
            src={require("./gloves.jpeg")}
            className="h-64 w-full object-cover rounded-lg"
            alt="logo"
          />
          <button className="border bg-gray-300 rounded-3xl px-4 py-1 mt-6 text-zinc-600 text-sm">
            LIFESTYLE
          </button>
          <h1 className="font-bold text-2xl mt-4 mb-4 cursor-pointer hover:text-red-500">
            EXTERIOR TRENCH <br /> TREATMENT
          </h1>
          <p className="text-zinc-600 font-medium text-sm leading-relaxed">
            Once the exterior walls are built, a trench is dug around the
            building to expose the footing, which is then thoroughly treated
            with our chemical solution.
          </p>
        </div>

        {/* Card 3 */}
        <div className="max-w-sm w-full text-center">
          <img
            src={require("./news-3.jpg")}
            className="h-64 w-full object-cover rounded-lg"
            alt="logo"
          />
          <button className="border bg-gray-300 rounded-3xl px-4 py-1 mt-6 text-zinc-600 text-sm">
            LIFESTYLE
          </button>
          <h1 className="font-bold text-2xl mt-4 mb-4 cursor-pointer hover:text-red-500">
            PAD TREATMENT
          </h1>
          <p className="text-zinc-600 font-medium text-sm leading-relaxed">
            Once the footing is poured and the exterior walls are constructed,
            the exposed soil beneath the slab is treated with our chemical
            solution.
          </p>
        </div>
      </div>
    </div>
  );
}
